import type { IconData } from '@stacksjs/iconify-core'

export const candleF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 9h6v6H7zm-5 8h16a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m8-8.6a3 3 0 0 1-3-3Q7 3.742 10 0q3 3.742 3 5.4a3 3 0 0 1-3 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default candleF
